(ns shared.core.amelia-light.components.tab
  (:require ["@up/base-ui/components/ui/tabs" :refer [Tabs
                                                      TabsList
                                                      TabsTrigger
                                                      TabsContent]]
            [shared.core.util :as util]))

(defn up-tabs-root [& args] (into [:> Tabs] args))
(defn up-tabs-list [& args] (into [:> TabsList] args))
(defn up-tabs-trigger [& args] (into [:> TabsTrigger] args))
(defn up-tabs-content [& args] (into [:> TabsContent] args))
(defn up-tabs [{:keys [tabs default-value style list-style list-container-style]}]
  (let [tab->value #(or (:value %) (util/->kebab-case-string (:label %)))
        tabs (mapv (fn [tab] (assoc tab :value (tab->value tab))) tabs)]
    (into [:> Tabs {:default-value (or default-value (-> tabs (first) :value))
                    :style style}
           [:div {:style (merge {:overflow-x :auto}
                                list-container-style)}
            (into [up-tabs-list {:style (merge {:width "max-content"
                                                :min-width "100%"}
                                               list-style)}]
                  (mapv (fn [{:keys [label] :as tab}]
                          (into [up-tabs-trigger {:value (tab->value tab)
                                                  :style {:flex-shrink 0}}]
                                label))
                        tabs))]]
          (mapv (fn [{:keys [content] :as tab}]
                  (into [up-tabs-content {:value (tab->value tab)}]
                        content))
                tabs))))
